import {cookieStore} from 'libs/storage/storage';
import {VISITOR_ID} from 'constants/cookie';
import uniqueId from 'libs/uniqueId';

/**
 * Return visitor identifier if it does not exist set it
 * @returns {string} identifier
 */
export function getVisitorId(): string {
    const id = cookieStore.get(VISITOR_ID);

    if (id) return id;

    const visitorId = uniqueId.generateId();
    cookieStore.set(VISITOR_ID, visitorId);

    return visitorId;
}
